(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-overview.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-overview.js');

'use strict';

svs.maltipset.views.BetslipOverview = Marionette.View.extend({
  className: 'maltipset-betslip-content',
  regions: {
    rows: '.rows'
  },
  events: {
    'click @ui.closeBtn': 'hideOddsFolder'
  },
  ui: {
    closeBtn: '.js-close-odds-folder'
  },
  template(data) {
    return svs.maltipset.templates.betslip_overview(data);
  },
  hideOddsFolder() {
    this.dimmer.removeClass('maltipset-betslipoverview-dimmer-visible');
    this.$el.parent().removeClass('maltipset-slider-folder-open');
    const textSpan = $('#betslip-overview').find('span');
    textSpan.text(textSpan.text() === 'Visa översikt av spelet' ? 'Dölj översikt av spelet' : 'Visa översikt av spelet');
  },
  onRender() {
    this.getRegion('rows').show(new svs.maltipset.views.BetslipContentRows({
      model: new svs.maltipset.models.Betslip({
        coupon: this.options.coupon
      }),
      betslip: this.options.betslip
    }));
    this.dimmer = this.dimmer || $('.maltipset-betslipoverview-dimmer');
    this.dimmer.on('click', this.hideOddsFolder.bind(this));
  }
});

 })(window);